const scrollToEl = () => {
  const nextFrameBtn = document.querySelectorAll('.js-scroll-next');
  if (!nextFrameBtn.length) return;
  nextFrameBtn.forEach($btn => {
    const $frame = $btn.closest('.frame');
    if (!$frame) return;
    const $nextFrame = $frame.nextElementSibling;
    $btn.addEventListener('click', e => {
      e.preventDefault();
      $nextFrame.scrollIntoView();
    });
  });
};
export default scrollToEl;